<div *ngIf="!(isConnected$ | async) && (isAuthenticated$ | async) && isWs" class="alert alert-danger" role="alert">
  {{ text }}
</div>
<div class="h-100" [class.disabled]="!(isConnected$ | async) && (isAuthenticated$ | async) && isWs">
  <ng-content></ng-content>
</div>
